import React, { useEffect, useState } from "react";
import BibGroupsForm from "./BibGroupsForm.jsx";
import EventCreation from "./EventCreation.jsx";
import UploadFile from "./UploadFile.jsx";
import EventControls from "./EventControls.jsx";
import PrizeGroups from "./PrizeGroups.jsx";
import { apiClient } from "../api_client.js";

export default function Wizard({id}) {
  const [step, setStep] = useState(1);
  const [eventId, setEventId] = useState(null);
  const today = new Date().toISOString().split("T")[0];
  const [eventInfoData, setEventInfoData] = useState({
    eventId: 0,
    name: "",
    description: "",
    date: today,
    image: "",
    bib_group_total: 1,
    organiser_name: "",
    organiser_email: "",
  });
  const [bibGroups, setBibGroups] = useState();
  const [bibRules, setBibRules] = useState();
  const [isDisabled, setDisabled] = useState([2, 3, 4, 5]);

  useEffect(() => {
    let ignore = false;
    if (id !== null){
      setEventId(id);
      setDisabled([]);
      apiClient.events.update(id)
        .then(result => {
        if (!ignore) {
          setEventInfoData({...eventInfoData, 
            eventId: id, 
            name: result.name, 
            description: result.description,
            date: result.date,
            //bib_group_total: bgt,
            organiser_name: result.organiser_name,
            organiser_email: result.organiser_email
          });
          setBibGroups(
            result.bib_groups.map(bibG => ({
              id: bibG.id,
              name: bibG.name,
              ranges: bibG.ranges.map(r => ({
                lower_range: r.lower_range,
                upper_range: r.upper_range
              })),
            }))
          );
          const rulesByCategory = {};

          result.bib_groups.forEach(group => {
            group.bib_rules.forEach(rule => {
              rulesByCategory[rule.category] = {
                groupId: group.id,
                end_of_year: rule.end_of_year
              };
            });
          });

          setBibRules(rulesByCategory);
        }
      });
    }
    else{
      apiClient.events.getOrganiser('events/new')
        .then(result => {
        if (!ignore) {
          setEventInfoData({
            ...eventInfoData, 
            organiser_name: result.name,
            organiser_email: result.email
          });        
        }
      });
    }
    return () => {
      ignore = true;
    };
  }, []);

  const handleStep1Success = (createdEventId, eventFormData) => {
    setEventInfoData(eventFormData);
    setEventId(createdEventId);

    removeDisabled([1,2]);
    setStep(2);
  }

  const handleStep2Success = ( createdBibGroups, createdBibRules) => {
    if (createdBibGroups != null && createdBibRules){
      setBibGroups(createdBibGroups);
      setBibRules(createdBibRules);
    }
    else {
      setBibGroups([]);
      setBibRules({});
    }
    removeDisabled([1,2,3]);
    setStep(3);
  };

  const handleStep3Success = () => {
    removeDisabled([1,2,3,4]);
    setStep(4);
  };

  const handleStep4Success = () => {
    removeDisabled([1,2,3,4,5]);
    setStep(5);
  };

  const handleStep5Success = () => {
    alert("Event setup complete!");
    window.location.href = `/events/${eventId}`;
  };

  const removeDisabled = (steps) => {
    setDisabled(prev => prev.filter(d => !steps.includes(d)));
  };

  return (
  <div className="d-flex">
    {/* Left sidebar buttons */}
    <div className="d-flex flex-column me-4" style={{ minWidth: "150px" }}>
      <button 
        className={`btn mb-2 ${step === 1 ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => setStep(1)}
      >
        Event Info
      </button>
      <button 
        className={`btn mb-2 ${step === 2 ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => setStep(2)}
        disabled={isDisabled.includes(2)}
      >
        Bib Rules
      </button>
      <button 
        className={`btn mb-2 ${step === 3 ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => setStep(3)}
        disabled={isDisabled.includes(2) || isDisabled.includes(3)}
      >
        Upload CSV
      </button>
      <button 
        className={`btn mb-2 ${step === 4 ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => setStep(4)}
        disabled={isDisabled.includes(4)}
      >
        Beacon Options
      </button>
      <button 
        className={`btn mb-2 ${step === 5 ? "btn-primary" : "btn-outline-primary"}`}
        onClick={() => setStep(5)}
        disabled={isDisabled.includes(5)}
      >
        Prize Groups
      </button>
    </div>

    {/* Right content */}
    <div className="flex-grow-1 mb-3 card p-4">
      {step === 1 && (
        <EventCreation
          eventId={eventId}
          persistedEventInfo={eventInfoData}
          onSuccess={handleStep1Success}
          />
      )}

      {step === 2 && (
        <BibGroupsForm
          initialBibGroups={bibGroups}
          initialBibRules={bibRules} 
          eventId={eventId}
          eventInfoData={eventInfoData}
          onSuccess={handleStep2Success}
        />
      )}

      {step === 3 && (
        <UploadFile 
          eventId={eventId}
          onSuccess={handleStep3Success}
        />
      )}

      {step === 4 && (
        <EventControls 
          id={eventId}
          eventInfoData={eventInfoData}
          bibGroups={bibGroups}
          bibRules={bibRules}
          onSuccess={handleStep4Success}
        />
      )}

      {step === 5 && (
        <PrizeGroups 
          id={eventId}
          eventInfoData={eventInfoData}
          bibGroups={bibGroups}
          bibRules={bibRules}
          onSuccess={handleStep5Success}
        />
      )}
    </div>
  </div>
  );
}